var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "app-wrapper", attrs: { id: "app" } }, [
    _c(
      "div",
      { staticClass: "sidebar", class: { collapsed: _vm.isCollapsed } },
      [
        _c("div", { staticClass: "logo" }, [
          !_vm.isCollapsed
            ? _c("span", [_vm._v("WJS组件库")])
            : _c("span", [_vm._v("WJS")]),
        ]),
        _vm._v(" "),
        _c(
          "el-menu",
          {
            attrs: {
              "default-active": _vm.$route.path,
              collapse: _vm.isCollapsed,
              "collapse-transition": false,
              router: "",
              "background-color": "#304156",
              "text-color": "#bfcbd9",
              "active-text-color": "#409EFF",
            },
          },
          [
            _c("el-menu-item", { attrs: { index: "/" } }, [
              _c("i", { staticClass: "el-icon-s-home" }),
              _vm._v(" "),
              _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                _vm._v("首页"),
              ]),
            ]),
            _vm._v(" "),
            _vm._l(_vm.menu, function (group) {
              return _c(
                "el-submenu",
                { key: group.index, attrs: { index: group.index } },
                [
                  _c("template", { slot: "title" }, [
                    _c("i", { class: group.icon }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(group.title))]),
                  ]),
                  _vm._v(" "),
                  _vm._l(group.items, function (item) {
                    return _c(
                      "el-menu-item",
                      { key: item.path, attrs: { index: item.path } },
                      [_vm._v(_vm._s(item.title))]
                    )
                  }),
                ],
                2
              )
            }),
          ],
          2
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "main-container" }, [
      _c("div", { staticClass: "header" }, [
        _c(
          "div",
          { staticClass: "header-left" },
          [
            _c("i", {
              staticClass: "el-icon-s-fold toggle-btn",
              on: { click: _vm.toggleSidebar },
            }),
            _vm._v(" "),
            _c(
              "el-breadcrumb",
              { attrs: { separator: "/" } },
              [
                _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                  _vm._v("首页"),
                ]),
                _vm._v(" "),
                _c("el-breadcrumb-item", [
                  _vm._v(_vm._s(_vm.$route.meta.title || "")),
                ]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "header-right" },
          [
            _c("i", { staticClass: "el-icon-bell" }),
            _vm._v(" "),
            _c(
              "el-dropdown",
              [
                _c(
                  "span",
                  { staticClass: "user-info" },
                  [
                    _c("el-avatar", {
                      attrs: { size: "small", icon: "el-icon-user-solid" },
                    }),
                    _vm._v("\n            管理员\n          "),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-dropdown-menu",
                  { attrs: { slot: "dropdown" }, slot: "dropdown" },
                  [
                    _c("el-dropdown-item", [_vm._v("个人中心")]),
                    _vm._v(" "),
                    _c("el-dropdown-item", [_vm._v("设置")]),
                    _vm._v(" "),
                    _c("el-dropdown-item", { attrs: { divided: "" } }, [
                      _vm._v("退出登录"),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "main-content" }, [_c("router-view")], 1),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }